export const sv = {
  errSave: 'Kunde inte spara ändringarna. Försök igen.',
  carCareLabel: 'Bilvårdsprofil',
  garageLabel: 'Verkstadsprofil',
  carCareDesc: 'Hantera bilvårdscentrets information och inställningar',
  garageDesc: 'Hantera verkstadens information och inställningar',
  cancel: 'Avbryt',
  save: 'Spara',
  edit: 'Redigera',
  basicInfo: 'Grundinformation',
  garageName: 'Verkstadsnamn',
  kommun: 'Kommun',
  selectKommun: 'Välj kommun',
  address: 'Adress',
  notProvided: 'Ej angivet',
  email: 'E-post',
  phone: 'Telefon',
  description: 'Beskrivning',
  aftercheckPrice: 'Pris efterkontroll (kr)',
  aftercheckPriceHint: 'Vad du tar betalt för att köra kundens bil till efterkontrollen.',
  noDescription: 'Ingen beskrivning',
  openingHours: 'Öppettider',
  bookingHorizon: 'Bokningsfönster (dagar)',
  bookingHorizonHint: 'Hur långt fram kunder kan boka. Lämna tomt för plattformens standard ({days} dagar).',
  bookingHorizonInherited: 'Standard ({days} dagar)',
  closedDays: 'Stängda dagar',
  closedDaysDesc: 'Dessa datum visas inte i kundernas bokningskalender. Kunder kan bara boka minst 24 timmar i förväg.',
  addClosedDay: 'Lägg till stängd dag',
  noClosedDays: 'Inga stängda dagar planerade.',
  logo: 'Logotyp',
  uploadImage: 'Ladda upp bild',
  errUploadLogo: 'Kunde inte ladda upp logotypen. Försök igen.',
  statistics: 'Statistik',
  rating: 'Betyg',
  reviews: 'Recensioner',
  status: 'Status',
  active: 'Aktiv',
  inactive: 'Inaktiv',
  serviceAreas: 'Serviceområden',
  nearbyKommuns: 'Närliggande kommuner',
}

export const en: typeof sv = {
  errSave: 'Could not save the changes. Try again.',
  carCareLabel: 'Car care profile',
  garageLabel: 'Garage profile',
  carCareDesc: 'Manage the car care center information and settings',
  garageDesc: 'Manage the garage information and settings',
  cancel: 'Cancel',
  save: 'Save',
  edit: 'Edit',
  basicInfo: 'Basic information',
  garageName: 'Garage name',
  kommun: 'Municipality',
  selectKommun: 'Select municipality',
  address: 'Address',
  notProvided: 'Not provided',
  email: 'Email',
  phone: 'Phone',
  description: 'Description',
  aftercheckPrice: 'Re-inspection fee',
  aftercheckPriceHint: 'What you charge for driving the customer’s car to the re-inspection.',
  noDescription: 'No description',
  openingHours: 'Opening hours',
  bookingHorizon: 'Booking window (days)',
  bookingHorizonHint: 'How far ahead customers can book. Leave blank for the platform default ({days} days).',
  bookingHorizonInherited: 'Default ({days} days)',
  closedDays: 'Closed days',
  closedDaysDesc: 'These dates are not shown in the customer booking calendar. Customers can only book at least 24 hours in advance.',
  addClosedDay: 'Add closed day',
  noClosedDays: 'No closed days scheduled.',
  logo: 'Logo',
  uploadImage: 'Upload image',
  errUploadLogo: 'Could not upload the logo. Try again.',
  statistics: 'Statistics',
  rating: 'Rating',
  reviews: 'Reviews',
  status: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  serviceAreas: 'Service areas',
  nearbyKommuns: 'Nearby municipalities',
}
